import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject, takeUntil} from 'rxjs';
import {MatError, MatInput} from '@angular/material/input';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {PasswordResetModel} from '../../../models/password-reset/password-reset.model';
import {AuthenticationService} from '../../../services/authentication/authentication.service';
import { passwordValidator } from '../../../validators/password-validator';
import {NgClass} from "@angular/common";

@Component({
    selector: 'app-forgot-password-page',
    imports: [
        MatInput,
        ReactiveFormsModule,
        NgClass,
        MatError,
    ],
    templateUrl: './forgot-password-page.component.html',
    styleUrl: './forgot-password-page.component.sass'
})
export class ForgotPasswordPageComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>()
    key: string = ''
    hidePassword: boolean = true;
    hidePasswordSec: boolean = true;
    hidePasswordConfirm: boolean = true;
    temporaryPasswordControl = new FormControl('', [Validators.required]);
    newPasswordControl = new FormControl('', [Validators.required, passwordValidator()]);
    passwordConfirmControl = new FormControl('')

    constructor(private activatedRoute: ActivatedRoute, private authenticationService: AuthenticationService, private router: Router) {
    }

    ngOnInit(): void {
        this.activatedRoute.params.subscribe(params => {
            this.key = params['uuid'];
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    saveNewPassword(): void {
        if (this.temporaryPasswordControl.invalid || this.newPasswordControl.invalid) {
            this.temporaryPasswordControl.markAsTouched();
            this.newPasswordControl.markAsTouched();
            return;
        }

        if (this.newPasswordControl.value !== this.passwordConfirmControl.value) {
            return;
        }

        const data: PasswordResetModel = {
            key: this.key,
            temporaryPassword: this.temporaryPasswordControl.value!,
            newPassword: this.newPasswordControl.value!
        }
        this.resetPassword(data);

    }

    private resetPassword(resetModel: PasswordResetModel): void {
        this.authenticationService.resetPassword(resetModel)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: any) => {
                    this.router.navigate(['/anmeldung']);

                },
                error: (error) => {
                    console.error(error)
                }
            })
    }
}
